import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { ResizableTable } from "../../../components/resizableTable/ResizableTable";
import { dateFormatterMomentV3 } from "../../../util/customFunctions";

const MsspTable = ({ title, tableData, currencySymbol, handleOppRowClick, buildColumnsFromConfig, createOpportunityTableColumns, getCellValue }) => {
  const { data = [], columns = [] } = tableData || {};

  // Build a lookup of field → type from LKP_DRILLDOWN_CONFIG for this table
  const fieldTypeMap = {};
  (columns || []).forEach((c) => { fieldTypeMap[c.field] = c.type; });

  // Wrap the shared getCellValue: if the column type is 'date', apply dateFormatterMomentV3
  const msspGetCellValue = (row, field, rowIndex) => {
    if (fieldTypeMap[field] === 'date') {
      const val = row[field];
      if (!val) return '';
      try { return dateFormatterMomentV3(val); } catch (_) { return ''; }
    }
    return getCellValue(row, field, rowIndex);
  };

  const resizableColumns = buildColumnsFromConfig(columns, data, msspGetCellValue, currencySymbol)
    || createOpportunityTableColumns(data, msspGetCellValue, currencySymbol);

  return (
    <Box mb={8}>
       <Typography variant="subtitle1" style={{ fontWeight: 600}}>
                     {title}
                   </Typography>
      <ResizableTable
        columns={resizableColumns}
        rows={data}
        getCellValue={msspGetCellValue}
        getCellStyle={() => ({})}
        rowKey="rowNum"
        hideSubHeaderRow={true}
        maxWidth="100%"
        onRowClick={handleOppRowClick ? (row) => handleOppRowClick(row) : undefined}
      />
    </Box>
  );
};

const MSSPFulfillment = ({
  classes,
  paperTitle,
  currencySymbol = "",
  msspFulfillmentData,
  handleOppRowClick,
  buildColumnsFromConfig,
  createOpportunityTableColumns,
  getCellValue,
}) => {
  if (!msspFulfillmentData || msspFulfillmentData === "") {
    return (
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
            <Typography variant="h5" className={classes.title} >
              {paperTitle || "MSSP"}
            </Typography>
          </Box>
          <Skeleton variant="rect" animation="wave" height={180} width="100%" style={{ marginBottom: "1.5rem" }} />
          <Skeleton variant="rect" animation="wave" height={80} width="100%" style={{ marginBottom: "1.5rem" }} />
          <Skeleton variant="rect" animation="wave" height={130} width="100%" />
        </Paper>
      </Grid>
    );
  }

  const { commitments, wonCustomerOpps, qualifiedPipeline } = msspFulfillmentData;
  const tableProps = { currencySymbol, handleOppRowClick, buildColumnsFromConfig, createOpportunityTableColumns, getCellValue };

  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Typography variant="h5" className={classes.title}>
            {paperTitle || "MSSP"}
          </Typography>
          <span className={classes.updateFrequency} style={{marginLeft: 0}}>{"Live Data"}</span>
        </Box>

        <MsspTable title="MSSP Commitments" tableData={commitments} {...tableProps} />
        <MsspTable title="MSSP Customer Opportunities won against MSSP Commitments" tableData={wonCustomerOpps} {...tableProps} />
        <MsspTable title="MSSP Customer Opportunities in Qualified Pipeline" tableData={qualifiedPipeline} {...tableProps} />
      </Paper>
    </Grid>
  );
};

export default MSSPFulfillment;
